import indexOf from 'lodash/indexOf';
import map from 'lodash/map';
import maxBy from 'lodash/maxBy';
import invert from 'lodash/invert';
import mapValues from 'lodash/mapValues';
import isNumber from 'lodash/isNumber';
import last from 'lodash/last';
import sumBy from 'lodash/sumBy';
import merge from 'lodash/merge';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import isEqual from 'lodash/isEqual';

export default {
  indexOf,
  map,
  maxBy,
  invert,
  isNumber,
  mapValues,
  last,
  sumBy,
  merge,
  debounce,
  cloneDeep,
  omit,
  isEqual
};
